import { AfterContentInit, Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[laAutofocus]',
})
export class AutofocusDirective implements AfterContentInit {
  private hasFocused = false;

  private readonly elementRef = inject(ElementRef);

  ngAfterContentInit() {
    if (!this.hasFocused) {
      setTimeout(() => this.elementRef.nativeElement.focus(), 100);
      this.hasFocused = true;
    }
  }
}
